angular.module('impactx.list').directive("ixResetFilter", function() {
    return {
        scope:
        {
            header: "="
        },
        restrict: 'EA',
        require: '^stTable',
        link: function(scope, element, attrs, ctrl) {
            return element.bind('click', function() {
                return scope.$evalAsync(function() {
                    var tableState;
                    tableState = ctrl.tableState();
                    tableState.search.predicateObject[scope.header.filterField] = undefined;
                    tableState.pagination.start = 0;
                    return ctrl.pipe();
                });
            });
        }
    };
});